module.exports = __webpack_public_path__ + "static/media/logo.733294ea.gif";